import Decimal from 'decimal.js';
import React from 'react';

import colorScales from '../../../utils/colorScales';

interface LegendProps {
    binCount: number;
    binStepSize: number;
    unitLabel?: string;
    unit: string;
    colorScaleLabel: string;
    height: number;
}

const Legend = ({ binCount, binStepSize, unitLabel, unit, colorScaleLabel, height }: LegendProps) => {
    const maxBinCount = 20;
    const displayEveryNthIndex = Math.ceil(binCount / maxBinCount);
    const colourScale = colorScales.find(({ label }) => label === colorScaleLabel)!.scale;
    const heightLegendBox = height / binCount;
    const widthLegendBox = 40;

    return (
        <g transform='translate(10, 10)'>
            <text fill='currentColor' transform='translate(0, 20)'>
                {unitLabel ? unitLabel : unit}
            </text>
            <g transform='translate(0, 30)'>
                {Array.from({ length: binCount }).map((_, i) => (
                    <rect key={i} width={widthLegendBox} height={heightLegendBox} y={i * heightLegendBox} style={{ fill: colourScale((i + 1) / binCount) }} />
                ))}
                {Array.from({ length: binCount + 1 }).map((_, i) => (
                    <text
                        fill='currentColor'
                        key={i}
                        x={widthLegendBox + 5}
                        y={i * heightLegendBox + 5}
                        style={{ display: 'inline-block', width: widthLegendBox }}
                    >
                        {i % displayEveryNthIndex === 0 && (
                            <>
                                {new Decimal(i).mul(binStepSize).toNumber()}
                                {i === binCount && '+'}
                            </>
                        )}
                    </text>
                ))}
            </g>
        </g>
    );
};

export default Legend;
